<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" @click="openModel('jfbz')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table
				:data="jfbzList"
				style="width: 100%"
				size="mini"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
				:max-height="maxHeight"
			>
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column width="160">
					<template slot="header" slot-scope="scope">
						创建时间
					</template>
					<template slot-scope="scope">
						{{ scope.row.create_time }}
					</template>
				</el-table-column>

				<el-table-column align="center" width="190">
					<template slot="header" slot-scope="scope">
						操作
					</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openModel('jfbz', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl === 'jfbz'" ref="form" :model="form.jfbz" label-width="80px">
					<el-form-item label="名称"><el-input v-model="form.jfbz.name" size="mini" style="width: 95%;"></el-input></el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				jfbz: {}
			},
			createModel: false,
			dialogType: 'jfbz',
			preUrl: 'jfbz', //api
			dialogId: 0,
			jfbzList: [],
			maxHeight: 0,
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.jfbzList = e.list;
			console.log(this.jfbzList);
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'jfbz':
					if (!item) {
						this.form.jfbz = {
							id: '',
							name: ''
						};
						this.dialogId = 0;
					} else {
						this.form.jfbz = {
							name: item.name
						};
						this.dialogId = item.id;
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.jfbz;
			let e = {
				name: f.name,
				cjr: this.user.id
			};
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
